import { useQuery } from "@grandvisionhq/graphql";
import { useIntl } from "@grandvisionhq/state";
import { isDefined } from "@grandvisionhq/utils";
import { mapGraphProductToVisualListingProduct } from "../../mappers/mappers/map-graph-product-to-visual-listing-product.js";
import { GET_PRODUCTS_BY_SKUS } from "../../operations/queries/operations/queries/get-products-by-skus.js";
import "../../operations/queries/operations/queries/get-products-by-skus-extended.js";
const useGetProductsBySkus = ({ skus }) => {
  const intl = useIntl();
  const result = useQuery(GET_PRODUCTS_BY_SKUS, {
    variables: { skus },
    context: { headers: { "Accept-Language": intl.locale } }
  });
  if (result.loading) {
    return { loading: result.loading };
  }
  return {
    listingProducts: result?.data?.getProductsBySKUs.map((prod) => mapGraphProductToVisualListingProduct(prod, intl)).filter(isDefined).sort(function(a, b) {
      return skus.indexOf(a.masterVariant.sku) - skus.indexOf(b.masterVariant.sku);
    })
  };
};
export {
  useGetProductsBySkus
};
//# sourceMappingURL=use-get-products-by-skus.js.map
